import { Flex, Heading, Image, Text } from '@homebotapp/hb-react-component-catalog'
import notFoundSrc from 'assets/homes/img/not_found.svg'

interface DownForMaintenanceProps {
  head: string
  body: string
}

export const DownForMaintenance = ({ head, body }: DownForMaintenanceProps) => {
  return (
    <Flex
      padding={4}
      align='center'
      justify='center'
      direction='column'
      textAlign='center'
      height={'100vh'}
      minHeight='calc(60vh - #{$global-nav-height})'
    >
      <Image mb={8} src={notFoundSrc} alt='Not found' />
      <Heading fontWeight='semibold'>{head}</Heading>
      <Text maxWidth='30rem'>{body}</Text>
    </Flex>
  )
}
